import { call, put, takeLatest } from 'redux-saga/effects';
import { Urls } from 'src/common/urls';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { getErrorFromResponse } from 'src/features/Security/networking/util';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';

function* sendChatMessageApi(action: Actions.SendChatMessageAction) {
    try {
        const response = yield call(
            NetworkingProvider.getInstance().getControlInterface().post,
            Urls.BACKEND.CHAT.CHAT,
            action.request,
        )
        yield put(Actions.sendChatMessageApiSuccess(action.request, response.data))
    } catch (err) {
        yield put(Actions.sendChatMessageApiError(getErrorFromResponse(err)));
    }
}

export default function* chatSagas() {
    yield takeLatest(ActionTypes.SEND_CHAT_MESSAGE_API, sendChatMessageApi)
}
